export function taskId(id) {
    return id.replaceAll(".", "|")
}
